import React from 'react';
import type { SeasonType } from '../..';
import Styles from './styles.scss';

interface VerticalSlideProps {
	activeSlot: SeasonType;
	topValue: string | undefined;
	bottomValue: string | undefined;
	align?: 'left' | 'right';
	children: (value: string) => React.ReactNode;
}

export const VerticalSlide = ({
	activeSlot,
	topValue,
	bottomValue,
	align = 'left',
	children,
}: VerticalSlideProps) => {
	if (topValue === undefined || bottomValue === undefined) return null;

	const isSameValue = topValue === bottomValue;
	const isPeak = activeSlot === 'peak';

	if (isSameValue)
		return (
			<div className={`${Styles.staticWrapper} ${Styles[align]}`}>
				{children(topValue)}
			</div>
		);

	return (
		<div className={`${Styles.verticalSlideWrapper} ${Styles[align]}`}>
			<div
				className={`${Styles.slideSlot} ${isPeak ? Styles.visible : Styles.hiddenTop}`}
				aria-hidden={!isPeak}
			>
				{children(topValue)}
			</div>
			<div
				className={`${Styles.slideSlot} ${!isPeak ? Styles.visible : Styles.hiddenBottom}`}
				aria-hidden={isPeak}
			>
				{children(bottomValue)}
			</div>
		</div>
	);
};
